/**
 * API Service
 * Web-only implementation using direct HTTP calls to gridX API
 */

import type { ApiResponse } from './types'
import { webApiService, setUnauthorizedHandler as setWebUnauthorizedHandler } from './api/webApiService'

// Re-export types
export type { ApiResponse }

// Re-export setUnauthorizedHandler from web service
export const setUnauthorizedHandler = setWebUnauthorizedHandler

// Export the web API service directly
export const apiService = webApiService

// Default export for ease of use
export default apiService
